import { Form, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  addDataToAllergyMedicationTable,
  book_appointment,
  book_Videoconsultaton,
  Store_formData,
  CreateMedicalinfo
} from "../../../../../../actions/InterBranchCoordinatorAction";
import {
  INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM,
  INTERBRANCH_MODAL_UPDATE,
  INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
} from "../../../../../../actions/type";
import {
  ADD_DATA_TO_ALLERGY_MEDICATION_REDUX,
  allergentOptions,
  allergyStatusOptions,
  EDIT_DATA_TO_ALLERGY_MEDICATION_REDUX,
  medicinesOptions,
  sinceOptions,
  statusOptions,
} from "../../../../../../Helpers/InterBranchConstants";
import {
  ALLERGY_REDUX_STATE,
  COMMON_DELETE_MODAL_NAME,
  MEDICINE_REDUX_STATE,
} from "../../../../../../Helpers/InterBranchConstants";
import { update_allergy_medication_info,fetch_consultationNow } from "../../../../../../actions/InterBranchCoordinatorAction";
import Dropdown from "../../../../../DropDown/Dropdown";
import "./allergiesandmedication.css";
import { ConsoleSqlOutlined } from "@ant-design/icons";

function AllergiesandMedication() {
  let dispatch = useDispatch();
  let history = useHistory();
  let { path, url } = useRouteMatch();
  let reduxData = useSelector((state) => state);
  let patientId = localStorage.getItem("PatientId")
  const allergies = useSelector(
    (state) => state?.interBranchCoordinator?.temp_appointment_form?.allergies
  );
  const medications = useSelector(
    (state) => state?.interBranchCoordinator?.temp_appointment_form?.medications
  );

  let appointment_form = useSelector(
    (state) => state?.interBranchCoordinator?.appointment_form
  );
  let temp_appointment_form = useSelector(
    (state) => state?.interBranchCoordinator?.temp_appointment_form
  );

  let userDetails = JSON.parse(localStorage.getItem("userData"));
  const userId = userDetails.profileId;
  let {
    chosendoctorId,
    chosenDate,
    chosenTime,
    typeOfConsultation,
    couponCode,
  } = reduxData?.interBranchCoordinator?.appointment_form;

  const [allergyForm] = Form.useForm();
  const [medicationForm] = Form.useForm();

  const [isEditted, setEditted] = useState(false);
   let [resumevisible, setResumevisible] = useState(false)
   const [validationPopupVisible, setValidationPopupVisible] = useState(false);
   const [validationMessage, setValidationMessage] = useState("");
   const [warningPopupVisible, setWarningPopupVisible] = useState(false);
   const [warningMessage, setWarningMessage] = useState("");
      const MINUTE_MS = 10000;

  useEffect(() => {
    preloadData();

    return () => dispatch({ type: INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM });
  }, []);

  // Keep temp form in sync when appointment_form loads asynchronously
  useEffect(() => {
    const hasIncomingAllergies = Array.isArray(appointment_form?.allergies) && appointment_form.allergies.length > 0;
    const hasIncomingMedications = Array.isArray(appointment_form?.medications) && appointment_form.medications.length > 0;
    const hasTempAllergies = Array.isArray(temp_appointment_form?.allergies) && temp_appointment_form.allergies.length > 0;
    const hasTempMedications = Array.isArray(temp_appointment_form?.medications) && temp_appointment_form.medications.length > 0;

    if ((hasIncomingAllergies && !hasTempAllergies) || (hasIncomingMedications && !hasTempMedications)) {
      preloadData();
    }
  }, [appointment_form?.allergies, appointment_form?.medications]);

  useEffect(() => {
    if (allergies?.length > 0 || medications?.length > 0) {
      setEditted(true);
    } else {
      setEditted(false);
    }
  }, [allergies, medications]);

useEffect(() => {

       
        const interval = setInterval(() => {
            consultationnow()
        }, MINUTE_MS);

        return () => clearInterval(interval);

    })

    function consultationnow() {
        try {
            dispatch(fetch_consultationNow(userId)).then((data) => {
                if (data.data.appointmentId != undefined) {
                    setResumevisible(true)
                  // setconsultationId(data.data.appointmentId);

                }
                else {

                    setResumevisible(false)
                }

            });
        } catch (error) {
            console.log("Error in fetch_clinic_speciality API", error);
        }
    }
  const preloadData = () => {
    const srcAllergies = Array.isArray(appointment_form?.allergies)
      ? appointment_form.allergies.map((item, idx) => ({
          // Preserve existing fields; ensure stable index
          index: typeof item.index === "number" ? item.index : idx,
          allergen: item.allergen ?? item.Allergent ?? item.allergyName ?? null,
          reaction: item.reaction ?? item.Reaction ?? null,
          status: item.status ?? item.Since ?? null,
        }))
      : [];

    const srcMedications = Array.isArray(appointment_form?.medications)
      ? appointment_form.medications.map((item, idx) => ({
          index: typeof item.index === "number" ? item.index : idx,
          medication: item.medication ?? item.Name ?? null,
          quantity: item.quantity ?? item.Quantity ?? null,
          frequency: item.frequency ?? item.Since ?? null,
          status: item.status ?? item.Status ?? null,
        }))
      : [];

    dispatch({
      type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
      payload: {
        allergies: srcAllergies,
        medications: srcMedications,
      },
    });
  };



  console.log("medications", medications)
  let videoconsultation = () => {
    // Check for empty rows first and show popup if any exist
    if (checkForEmptyRowsAndShowPopup()) {
      return; // Stop execution if there are empty rows
    }

    try {
      dispatch(
        book_Videoconsultaton(
          patientId,
          userId,
          chosendoctorId,
          typeOfConsultation,
          couponCode,
          chosenTime,
          chosenDate,
          appointment_form
        )
      ).then((res) => {
        if (
          res.data.appointmentId !=
          "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience."
        ) {
          localStorage.setItem("AppointmentId", res.data.appointmentId);
          history.push("/meetspoke/" + res.data.appointmentId);
        }
      });
    } catch (error) {
      //console.log("Error in book_appointment API", error);
    }
  };

  // Helper function to check if all existing allergy rows are complete
  const areAllAllergyRowsComplete = () => {
    if (!allergies || allergies.length === 0) return true;
    
    return allergies.every(allergy => 
      allergy.allergen && allergy.allergen.trim() !== "" &&
      allergy.reaction && allergy.reaction.trim() !== "" &&
      allergy.status && allergy.status.trim() !== ""
    );
  };

  let addNewRowInAllergies = () => {
    // Check if all existing rows are complete before allowing new row
    if (!areAllAllergyRowsComplete()) {
      dispatch({
        type: INTERBRANCH_MODAL_UPDATE,
        payload: { 
          modalName: "commomAlertModal", 
          isVisible: true, 
          data: "Please complete all existing allergy entries before adding a new one." 
        }
      });
      return;
    }

    const nextIndex = allergies && allergies.length > 0
      ? Math.max(...allergies.map((a) => (typeof a.index === "number" ? a.index : -1))) + 1
      : 0;
    let payloadData = {
      index: nextIndex,
      allergen: null,
      reaction: null,
      status: null,
    };

    let tempExisting = temp_appointment_form?.allergies
      ? temp_appointment_form.allergies
      : [];
    dispatch({
      type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
      payload: { allergies: [...tempExisting, payloadData] },
    });
  };

  // Helper function to check if all existing medication rows are complete
  const areAllMedicationRowsComplete = () => {
    if (!medications || medications.length === 0) return true;
    
    return medications.every(medication => 
      medication.medication && medication.medication.trim() !== "" &&
      medication.quantity && medication.quantity.trim() !== "" &&
      medication.frequency && medication.frequency.trim() !== "" &&
      medication.status && medication.status.trim() !== ""
    );
  };

  // Helper function to check for empty rows and show popup
  const checkForEmptyRowsAndShowPopup = () => {
    const emptyAllergies = allergies ? allergies.filter((allergy, index) => 
      !allergy.allergen || allergy.allergen.trim() === "" ||
      !allergy.reaction || allergy.reaction.trim() === "" ||
      !allergy.status || allergy.status.trim() === ""
    ) : [];

    const emptyMedications = medications ? medications.filter((medication, index) => 
      !medication.medication || medication.medication.trim() === "" ||
      !medication.quantity || medication.quantity.trim() === "" ||
      !medication.frequency || medication.frequency.trim() === "" ||
      !medication.status || medication.status.trim() === ""
    ) : [];

    if (emptyAllergies.length > 0 || emptyMedications.length > 0) {
      let message = "Please complete the following incomplete entries:\n\n";
      
      if (emptyAllergies.length > 0) {
        message += "🔴 ALLERGY ENTRIES\n";
        
        allergies.forEach((allergy, index) => {
          if (!allergy.allergen || allergy.allergen.trim() === "" ||
              !allergy.reaction || allergy.reaction.trim() === "" ||
              !allergy.status || allergy.status.trim() === "") {
            const missingFields = [];
            if (!allergy.allergen || allergy.allergen.trim() === "") missingFields.push("Allergen");
            if (!allergy.reaction || allergy.reaction.trim() === "") missingFields.push("Reaction");
            if (!allergy.status || allergy.status.trim() === "") missingFields.push("Status");
            
            //message += `   • Row ${index + 1}: Missing ${missingFields.join(", ")}\n`;
          }
        });
        message += "\n";
      }
      
      if (emptyMedications.length > 0) {
        message += "🔴 MEDICATION ENTRIES\n";
        
        medications.forEach((medication, index) => {
          if (!medication.medication || medication.medication.trim() === "" ||
              !medication.quantity || medication.quantity.trim() === "" ||
              !medication.frequency || medication.frequency.trim() === "" ||
              !medication.status || medication.status.trim() === "") {
            const missingFields = [];
            if (!medication.medication || medication.medication.trim() === "") missingFields.push("Medicine Name");
            if (!medication.quantity || medication.quantity.trim() === "") missingFields.push("Quantity");
            if (!medication.frequency || medication.frequency.trim() === "") missingFields.push("Frequency");
            if (!medication.status || medication.status.trim() === "") missingFields.push("Status");
            
           // message += `   • Row ${index + 1}: Missing ${missingFields.join(", ")}\n`;
          }
        });
        message += "\n";
      }
      
      message += "Please fill in all required fields before proceeding.";

      setValidationMessage(message);
      setValidationPopupVisible(true);
      return true; // Has empty rows
    }
    return false; // No empty rows
  };

  // Helper function to check for empty rows and show warning popup
  const checkForEmptyRowsAndShowWarning = () => {
    const emptyAllergies = allergies ? allergies.filter((allergy, index) => 
      !allergy.allergen || allergy.allergen.trim() === "" ||
      !allergy.reaction || allergy.reaction.trim() === "" ||
      !allergy.status || allergy.status.trim() === ""
    ) : [];

    const emptyMedications = medications ? medications.filter((medication, index) => 
      !medication.medication || medication.medication.trim() === "" ||
      !medication.quantity || medication.quantity.trim() === "" ||
      !medication.frequency || medication.frequency.trim() === "" ||
      !medication.status || medication.status.trim() === ""
    ) : [];

    if (emptyAllergies.length > 0 || emptyMedications.length > 0) {
      let message = "WARNING: You have incomplete entries that will be excluded from saving:\n\n";
      
      if (emptyAllergies.length > 0) {
       // message += "🔴 INCOMPLETE ALLERGY ENTRIES:\n";
        allergies.forEach((allergy, index) => {
          if (!allergy.allergen || allergy.allergen.trim() === "" ||
              !allergy.reaction || allergy.reaction.trim() === "" ||
              !allergy.status || allergy.status.trim() === "") {
            const missingFields = [];
            if (!allergy.allergen || allergy.allergen.trim() === "") missingFields.push("Allergen");
            if (!allergy.reaction || allergy.reaction.trim() === "") missingFields.push("Reaction");
            if (!allergy.status || allergy.status.trim() === "") missingFields.push("Status");
            //message += `   • Row ${index + 1}: Missing ${missingFields.join(", ")}\n`;
          }
        });
        //message += "\n";
      }
      
      if (emptyMedications.length > 0) {
       // message += "🔴 INCOMPLETE MEDICATION ENTRIES:\n";
        medications.forEach((medication, index) => {
          if (!medication.medication || medication.medication.trim() === "" ||
              !medication.quantity || medication.quantity.trim() === "" ||
              !medication.frequency || medication.frequency.trim() === "" ||
              !medication.status || medication.status.trim() === "") {
            const missingFields = [];
            if (!medication.medication || medication.medication.trim() === "") missingFields.push("Medicine Name");
            if (!medication.quantity || medication.quantity.trim() === "") missingFields.push("Quantity");
            if (!medication.frequency || medication.frequency.trim() === "") missingFields.push("Frequency");
            if (!medication.status || medication.status.trim() === "") missingFields.push("Status");
            //message += `   • Row ${index + 1}: Missing ${missingFields.join(", ")}\n`;
          }
        });
        //message += "\n";
      }
      
      message += "Do you want to proceed and save only the complete entries?";

      setWarningMessage(message);
      setWarningPopupVisible(true);
      return true; // Has empty rows
    }
    return false; // No empty rows
  };

  let addNewMedicine = () => {
    // Check if all existing rows are complete before allowing new row
    if (!areAllMedicationRowsComplete()) {
      dispatch({
        type: INTERBRANCH_MODAL_UPDATE,
        payload: { 
          modalName: "commomAlertModal", 
          isVisible: true, 
          data: "Please complete all existing medication entries before adding a new one." 
        }
      });
      return;
    }

    const nextIndex = medications && medications.length > 0
      ? Math.max(...medications.map((m) => (typeof m.index === "number" ? m.index : -1))) + 1
      : 0;
    let payloadData = {
      index: nextIndex,
      medication: null,
      quantity: null,
      frequency: null,
      status: null,
    };
    let tempExisting = temp_appointment_form?.medications
      ? temp_appointment_form.medications
      : [];

    dispatch({
      type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
      payload: { medications: [...tempExisting, payloadData] },
    });
  };

  let removeAllergie = (index, name) => {
    Modal.confirm({
      title: "Delete allergy?",
      content: name ? `Are you sure you want to delete "${name}"?` : "Are you sure you want to delete this allergy?",
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () => {
        dispatch({
          type: "REMOVE_DATA_FROM_ALLERGY_MEDICATION_REDUX",
          payload: { stateName: "allergies", index },
        });
      },
    });
  };

  let removeMedicine = (index, name) => {
    Modal.confirm({
      title: "Delete medication?",
      content: name ? `Are you sure you want to delete "${name}"?` : "Are you sure you want to delete this medication?",
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () => {
        dispatch({
          type: "REMOVE_DATA_FROM_ALLERGY_MEDICATION_REDUX",
          payload: { stateName: "medications", index },
        });
      },
    });
  };

  let updateTable = (value, id, name, index) => {
    let stateName = id;
    let key = name;

    // //console.log(stateName, key, value, index);

    dispatch({
      type: EDIT_DATA_TO_ALLERGY_MEDICATION_REDUX,
      payload: { stateName, key, value, index },
    });
  };

  let handleSave = async () => {
    try {
      // Check for empty rows and show warning popup if any exist
      if (checkForEmptyRowsAndShowWarning()) {
        return; // Show warning popup and wait for user decision
      }

      // If no empty rows, proceed with normal save
      await proceedWithSave();
    } catch (error) {
      if (error?.errorFields?.length < 0 || !error) {
      }
    }
  };

  // Function to proceed with saving (called from warning popup or normal save)
  const proceedWithSave = async () => {
    try {
      // Validate that we have actual data to save
      const hasValidAllergies = allergies && allergies.length > 0 && 
        allergies.some(allergy => 
          allergy.allergen && allergy.allergen.trim() !== "" &&
          allergy.reaction && allergy.reaction.trim() !== "" &&
          allergy.status && allergy.status.trim() !== ""
        );
      
      const hasValidMedications = medications && medications.length > 0 && 
        medications.some(medication => 
          medication.medication && medication.medication.trim() !== "" &&
          medication.quantity && medication.quantity.trim() !== "" &&
          medication.frequency && medication.frequency.trim() !== "" &&
          medication.status && medication.status.trim() !== ""
        );

      // If no valid data, show error message
      if (!hasValidAllergies && !hasValidMedications) {
        dispatch({
          type: INTERBRANCH_MODAL_UPDATE,
          payload: { 
            modalName: "commomAlertModal", 
            isVisible: true, 
            data: "Please add at least one allergy or medication with complete information before saving." 
          }
        });
        return;
      }

      // Filter out empty/incomplete entries before saving
      const validAllergies = allergies ? allergies.filter(allergy => 
        allergy.allergen && allergy.allergen.trim() !== "" &&
        allergy.reaction && allergy.reaction.trim() !== "" &&
        allergy.status && allergy.status.trim() !== ""
      ) : [];

      const validMedications = medications ? medications.filter(medication => 
        medication.medication && medication.medication.trim() !== "" &&
        medication.quantity && medication.quantity.trim() !== "" &&
        medication.frequency && medication.frequency.trim() !== "" &&
        medication.status && medication.status.trim() !== ""
      ) : [];

      try {
        //console.log("Allergy, Medication details b4 calling API", validAllergies, validMedications);
        dispatch(
          update_allergy_medication_info(patientId, validAllergies, validMedications)
        );
        dispatch(CreateMedicalinfo(patientId, localStorage.getItem("appointmentId")))
      } catch (error) {
        console.log("Error in profile API", error);
      }

      history.push(
        `/dashboard/${url.includes("bookandconsult")
          ? "bookandconsult"
          : "scheduleappointment"
        }/consultationhistory`
      );
    } catch (error) {
      console.log("Error in proceedWithSave", error);
    }
  };

  // Handle proceed from warning popup
  const handleProceedFromWarning = () => {
    setWarningPopupVisible(false);
    proceedWithSave();
  };

  // Handle go back from warning popup
  const handleGoBackFromWarning = () => {
    setWarningPopupVisible(false);
  };

  let isScheduled = () => {
    return url.includes("scheduleappointment");
  };

  let validateAlphaNumericsOnly = (event) => {
    if (!event.key.match(new RegExp("^[a-zA-Z0-9_ ]*$"))) {
      event.preventDefault();
    }
  };

  function allowOnlyNumericsOrDigits(e) {
    if (e.target.value.includes(".") && e.key == ".") {
      e.preventDefault();
    }

    ![
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ".",
      "Backspace",
    ].includes(e.key) && e.preventDefault();
  }

  const onFinishAllergies = (values) => {
    console.log(values);

    addNewRowInAllergies();
  };

  const onFinishFailedAllergies = (error) => {
    // console.log(error);
  };

  const onFinishMedication = (values) => {
    console.log(values);

    addNewMedicine();
  };

  const onFinishFailedMedication = (error) => {
    // console.log(error);
  };

  return (
    <>
      <div className="main-container">
        <div className="sub-container-row">
          <Form
            form={allergyForm}
            name="allergyForm"
            onFinish={onFinishAllergies}
            onFinishFailed={onFinishFailedAllergies}
            autoComplete="off"
            preserve={true}
            initialValues={{ allergies }}
          >
            <div className="am-table-container">
              <div className="table-header">
                <span>Allergies</span>
                
              </div>

              <table>
                <tr>
                  <th>Allergen</th>
                  <th>Reaction</th>
                  <th>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span>Status</span>
                      
                    </div>
                  </th>
                  <th></th>
                  <th><button
                        type="button"
                        className="add-alergie-button"
                        onClick={addNewRowInAllergies}
                        style={{
                          marginLeft: 8,
                          padding: "4px 6px",
                          backgroundColor: "#1890ff",
                          color: "#fff",
                          borderRadius: 4,
                          display: "inline-flex",
                          alignItems: "center"
                        }}
                        aria-label="Add Allergy"
                        title="Add Allergy"
                      >
                        <img
                          src={require("../../../../../../assets/InterBranch/PNGIcons/more.png")}
                          alt="add"
                        />
                      </button></th>
                </tr>

                <tbody>
                  {allergies && allergies.length > 0 ? (
                    allergies.map((element, key) => {
                      return (
                        <tr key={`allergy-${element.index}-${key}`}>
                          <td>
                            <Form.Item
                              name={["allergies", element.index, "allergen"]}
                              rules={[{ required: true, message: "Please enter allergen" }]}
                              initialValue={element.allergen || ""}
                            >
                              <Input
                                className="reaction"
                                onChange={(e) =>
                                  updateTable(
                                    e.target.value,
                                    "allergies",
                                    "allergen",
                                    element.index
                                  )
                                }
                                value={element.allergen || ""}
                                style={{ width: "100%" }}
                                placeholder="Allergen"
                                onKeyDown={validateAlphaNumericsOnly}
                                maxLength={25}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={["allergies", element.index, "reaction"]}
                              rules={[{ required: true, message: "Please enter reaction" }]}
                              initialValue={element.reaction || ""}
                            >
                              <Input
                                className="reaction"
                                onChange={(e) =>
                                  updateTable(
                                    e.target.value,
                                    "allergies",
                                    "reaction",
                                    element.index
                                  )
                                }
                                value={element.reaction || ""}
                                style={{ width: "100%" }}
                                placeholder="Reaction"
                                maxLength={200}
                                onKeyDown={validateAlphaNumericsOnly}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={["allergies", element.index, "status"]}
                              rules={[{ required: true, message: "Please select status" }]}
                              initialValue={element.status || undefined}
                            >
                              <Dropdown
                                name="status"
                                id="allergies"
                                index={element.index}
                                data={allergyStatusOptions}
                                onChange={(value) =>
                                  updateTable(
                                    value,
                                    "allergies",
                                    "status",
                                    element.index
                                  )
                                }
                                width={"100%"}
                                placeholder="Select Status"
                                isV2
                                value={element.status || undefined}
                              />
                            </Form.Item>
                          </td>

                        <td >
                          <img
                            onClick={() => {
                              removeAllergie(
                                element.index,
                                element.allergen || null
                              );
                            }}
                            style={{ cursor: "pointer", marginTop: 0 }}
                            src={require("../../../../../../assets/InterBranch/PNGIcons/delete.png")}
                            alt=""
                          />
                        </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4}>
                        <div className="no-data">
                          <img
                            src={require("../../../../../../assets/InterBranch/PNGIcons/no_allergies.png")}
                            alt=""
                          />

                          <span>No data available</span>
                          
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Form>

          <Form
            form={medicationForm}
            name="medicationForm"
            onFinish={onFinishMedication}
            onFinishFailed={onFinishFailedMedication}
            autoComplete="off"
            preserve={true}
            initialValues={{ medications }}
          >
            <div className="am-table-container">
              < div className="table-header">
                <span>Medication</span>
                
              </div>

              <table>
                <thead>
                  <tr>
                    <th>Medicine Name</th>
                    <th>Quantity</th>
                    <th>Frequency</th>
                    <th colSpan={2}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span>Status</span>
                       
                      </div>
                    </th>
                    <th> <button
                          type="button"
                          className="add-alergie-button"
                          onClick={addNewMedicine}
                        style={{
                          marginLeft: 8,
                          padding: "4px 6px",
                          backgroundColor: "#1890ff",
                          color: "#fff",
                          borderRadius: 4,
                          display: "inline-flex",
                          alignItems: "center"
                        }}
                          aria-label="Add Medication"
                          title="Add Medication"
                        >
                          <img
                            src={require("../../../../../../assets/InterBranch/PNGIcons/more.png")}
                            alt="add"
                          />
                        </button></th>
                  </tr>
                </thead>

                <tbody>
                  {medications && medications.length > 0 ? (
                    medications.map((element, key) => (
                      <tr key={`medication-${element.index}-${key}`}>
                        <td>
                          <Form.Item
                            name={["medications", element.index, "medication"]}
                            rules={[{ required: true, message: "Please enter medicine name" }]}
                            initialValue={element.medication || ""}
                          >
                            <Input
                              className="reaction"
                              maxLength={30}
                              placeholder="Medicine Name"
                              style={{ width: "100%" }}
                              onChange={(e) =>
                                updateTable(e.target.value, "medications", "medication", element.index)
                              }
                              onKeyDown={validateAlphaNumericsOnly}
                            />
                          </Form.Item>
                        </td>

                        <td>
                          <Form.Item
                            name={["medications", element.index, "quantity"]}
                            rules={[{ required: true, message: "Please enter quantity" }]}
                            initialValue={element.quantity || ""}
                          >
                            <Input
                              maxLength={4}
                              placeholder="Quantity"
                              style={{ width: "100%" }}
                              className="reaction"
                              onChange={(e) =>
                                updateTable(e.target.value, "medications", "quantity", element.index)
                              }
                              onKeyDown={allowOnlyNumericsOrDigits}
                            />
                          </Form.Item>
                        </td>

                        <td>
                          <Form.Item
                            name={["medications", element.index, "frequency"]}
                            rules={[{ required: true, message: "Please select frequency" }]}
                            initialValue={element.frequency || undefined}
                          >
                            <Dropdown
                              name="frequency"
                              id="medications"
                              index={element.index}
                              data={sinceOptions}
                              width={300}
                              placeholder="Select Frequency"
                              isV2
                              value={element.frequency || undefined}
                              onChange={(value) =>
                                updateTable(value, "medications", "frequency", element.index)
                              }
                            />
                          </Form.Item>
                        </td>

                        <td>
                          <Form.Item
                            name={["medications", element.index, "status"]}
                            rules={[{ required: true, message: "Please select status" }]}
                            initialValue={element.status || undefined}
                          >
                            <Dropdown
                              name="status"
                              id="medications"
                              index={element.index}
                              data={statusOptions}
                              width={190}
                              placeholder="Select Status"
                              isV2
                              value={element.status || undefined}
                              onChange={(value) =>
                                updateTable(value, "medications", "status", element.index)
                              }
                            />
                          </Form.Item>
                        </td>

                        <td >
                          <img
                            style={{ cursor: "pointer", marginTop: 0 }}
                            onClick={() =>
                              removeMedicine(
                                element.index,
                                element.medication || "Medicine"
                              )
                            }
                            src={require("../../../../../../assets/InterBranch/PNGIcons/delete.png")}
                            alt="delete"
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5}>
                        <div className="no-data">
                          <img
                            src={require("../../../../../../assets/InterBranch/PNGIcons/no_medicines.png")}
                            alt=""
                          />
                          <span>No data available</span>
                         
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Form>

        </div>
      </div>

      <div className="button-container">
        <button
          onClick={handleSave}
          disabled={!isEditted}
          className="submt-btn"
        >
          SAVE
        </button>

        

        {/* {
                    isScheduled() &&
                    <button className='join-btn' onClick={bookappointment}>BOOK APPOINTMENT</button>
                    // :
                    // <button disabled={!isCouponCodeVerified()} className='join-btn' onClick={() => setButtonClicked("Book")}>BOOK APPOINTMENT</button>
                } */}
        {
          !isScheduled() && !resumevisible &&(
            <button className="join-btn" onClick={videoconsultation}>
              SKIP AND JOIN CONSULTATION
            </button>
          )
          // :
          // <button disabled={!isCouponCodeVerified()} className='join-btn' onClick={() => setButtonClicked("Book")}>BOOK APPOINTMENT</button>
        }
      </div>

      {/* Validation Popup */}
      <Modal
       
        open={validationPopupVisible}
        onCancel={() => setValidationPopupVisible(false)}
        footer={[
          <button
            key="ok"
            onClick={() => setValidationPopupVisible(false)}
            style={{
              backgroundColor: '#ff4d4f',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            OK, I'll Fix Them
          </button>
        ]}
        width={500}
        centered
      >
        <div style={{ 
          padding: '16px 0',
          fontSize: '17px',
          lineHeight: '1.6',
          whiteSpace: 'pre-line',
          color: '#333',
          fontWeight:"500",
        }}>
          {validationMessage}
        </div>
      </Modal>

      {/* Warning Popup */}
      <Modal
        title={
          <div style={{ color: '#faad14', fontWeight: 'bold', fontSize: '18px' }}>
            ⚠️ Warning
          </div>
        }
        open={warningPopupVisible}
        onCancel={handleGoBackFromWarning}
        footer={[
          <button
            key="goBack"
            onClick={handleGoBackFromWarning}
            style={{
              backgroundColor: '#d9d9d9',
              color: '#333',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
              marginRight: '8px'
            }}
          >
            Go Back
          </button>,
          <button
            key="proceed"
            onClick={handleProceedFromWarning}
            style={{
              backgroundColor: '#52c41a',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            Proceed
          </button>
        ]}
        width={500}
        centered
      >
        <div style={{ 
          padding: '16px 0',
          fontSize: '14px',
          lineHeight: '1.6',
          whiteSpace: 'pre-line',
          color: '#333'
        }}>
          {warningMessage}
        </div>
      </Modal>
    </>
  );
}

export default AllergiesandMedication;
